import { useCallback, useEffect, useState } from "react";
import { Table } from "@awsui/components-react";
import {
  TableHeader,
  Preferences,
  DeleteModal,
} from "./ListEndpointsComponents";

import { ContentContainer } from "../shared/Components";
import {
  Campaign,
  ListJobsTableRecord,
  CampaignPrefilteringEndpoint,
} from "../../appstore/models";
import { deleteJobs } from "./listEndpointsHelpers";
// import { useStoreState } from "../../appstore";
import { listCampaignPrefilteringEndpoints } from "../../common/api";

export const LIST_JOBS_COLUMN_DEFINITIONS: ListJobsTableRecord[] = [
  {
    id: "CampaignPrefilteringEndpointName",
    header: "Name",
    cell: (item) => item.CampaignPrefilteringEndpointName,
    minWidth: 200,
    allowLineWrap: true,
  },
  {
    id: "Description",
    header: "Description",
    cell: (item) => item.Description,
    minWidth: 130,
    allowLineWrap: true,
  },
  {
    id: "EndpointName",
    header: "Sagemaker Endpoint",
    cell: (item) => item.EndpointName,
    minWidth: 150,
    allowLineWrap: true,
  },
  {
    id: "EndpointType",
    header: "Endpoint Type",
    cell: (item) => item.EndpointType,
    minWidth: 130,
    allowLineWrap: true,
  },
];

const ListEndpoints = () => {
  // const geoEndpointIds = useStoreState((s) => s.geoInferenceEndpoints.ids);
  // const [searchTriggered, setSearchTriggered] = useState(true);
  let [campaignPrefilteringEndpoints, setCampaignPrefilteringEndpoints] =
    useState<CampaignPrefilteringEndpoint[]>([]);
  //let [pageCount, setPageCount] = useState<number>(0);
  let [loading, setLoading] = useState<boolean>(false);
  let [selectedGeoEndpoints, setSelectedGeoEndpoints] = useState<Campaign[]>(
    []
  );
  // let [searchQuery, setSearchQuery] = useState<string>("");
  //let [currentPageIndex, setCurrentPageIndex] = useState<number>(1);
  let [preferences, setPreferences] = useState({
    pageSize: 10,
    visibleContent: [
      "CampaignPrefilteringEndpointName",
      "Description",
      "EndpointName",
      "EndpointType",
    ],
    wrapLines: false,
  });

  // let [nextToken, setNextToken] = useState<AWS.DynamoDB.Key | undefined>();
  let [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  /*
  const calculatePageCount = useCallback(
    (totalJobs: number) => {
      return Math.ceil(totalJobs / preferences.pageSize);
    },
    [preferences.pageSize]
  );
  const jobSearchParameters = useMemo(() => {
    const request: ListGeoEndpointsFilter = {
      PageNumber: currentPageIndex,
      MaxResults: preferences.pageSize,
      Filter: {},
      NextToken: nextToken,
    }; // Add filter options
    if (searchQuery.trim() !== "") {
      request.Filter.name = searchQuery.trim();
    }
    return request;
  }, [currentPageIndex, nextToken, preferences.pageSize, searchQuery]);
  useEffect(() => {
    if (geoEndpointIds.length > 0) {
      setSearchTriggered(true);
    }
  }, [geoEndpointIds]);
  */

  const loadJobs = useCallback(async () => {
    setLoading(true);

    const response = await listCampaignPrefilteringEndpoints(100);
    setCampaignPrefilteringEndpoints(response.campaignPrefilteringEndpoints);
    //setPageCount(calculatePageCount(response.count));
    // setNextToken(response.LastEvaluatedKey);
    setLoading(false);
  }, [setCampaignPrefilteringEndpoints]);

  useEffect(() => {
    loadJobs();
  }, [loadJobs]);
  /*
  useEffect(() => {
    if (searchTriggered) {
      loadJobs();
      setSearchTriggered(false);
    }
  }, [searchTriggered, loadJobs]);
  const searchWithFilter = (filterText: string) => {
    setSearchQuery(filterText);
    setCurrentPageIndex(1);
    setSearchTriggered(true);
  };

  const clearFilter = () => {
    setSearchQuery("");
    setCurrentPageIndex(1);
    setSearchTriggered(true);
  };

  const fetchPage = (pageNumber: number) => {
    setCurrentPageIndex(pageNumber);
    setSearchTriggered(true);
  };
  */

  const deleteSelectedJobs = async () => {
    const request = {
      JobIDs: selectedGeoEndpoints.map((job) => job.JobName),
    };

    let response = deleteJobs(request);
    if (response.status === "ok") {
      //setCurrentPageIndex(1);
      toggleDeleteModal();
    }
  };

  const toggleDeleteModal = () => {
    let currentModalVisibility = showDeleteModal;
    setShowDeleteModal(!currentModalVisibility);
  };

  /*
  // Todo: add back to table component
        filter={
          <TextFilter
            filteringText={searchQuery}
            filteringPlaceholder="Find endpoints"
            onChange={({ detail }) => searchWithFilter(detail.filteringText)}
          />
        }
        empty={<TableEmptyState onClearFilter={clearFilter} />}

        pagination={
          <Pagination
            ariaLabels={{
              nextPageLabel: "Next page",
              previousPageLabel: "Previous page",
              pageLabel: (pageNumber) => `Page ${pageNumber} of all pages`,
            }}
            currentPageIndex={currentPageIndex}
            onChange={({ detail }) => fetchPage(detail.currentPageIndex)}
            pagesCount={pageCount}
          />
        }
  */

  return (
    <ContentContainer>
      <Table
        columnDefinitions={LIST_JOBS_COLUMN_DEFINITIONS}
        visibleColumns={preferences.visibleContent}
        items={campaignPrefilteringEndpoints}
        stickyHeader={true}
        resizableColumns={true}
        loading={loading}
        loadingText="Loading endpoints"
        wrapLines={preferences.wrapLines}
        header={
          <TableHeader
            title="Geospatial Inference Endpoints"
            deleteDisabled={selectedGeoEndpoints.length === 0}
            deleteCallback={toggleDeleteModal}
          />
        }
        selectionType="multi"
        selectedItems={selectedGeoEndpoints}
        onSelectionChange={({ detail }) =>
          setSelectedGeoEndpoints(detail.selectedItems)
        }
        preferences={
          <Preferences
            preferences={preferences}
            setPreferences={setPreferences}
          />
        }
      ></Table>
      <DeleteModal
        onConfirm={deleteSelectedJobs}
        onCancel={toggleDeleteModal}
        selectedJobs={selectedGeoEndpoints}
        isVisible={showDeleteModal}
      />
    </ContentContainer>
  );
};

export default ListEndpoints;
